import { AxiosResponse } from 'axios';
import { CardLoader } from 'components/common/Loading';
import { ReadOnlyQuill } from 'components/WYSIWYG/ReadOnlyQuill';
import { QuillPreview } from 'components/WYSIWYG/WYSIWYG.styled';
import React, { Fragment, ReactElement } from 'react';

type Props = {
  isLoading: boolean;
  data?: AxiosResponse<string>;
};

export default function ReleaseNotesContent({
  isLoading,
  data,
}: Props): ReactElement {
  const content = data?.data;

  return (
    <Fragment>
      {isLoading && !Boolean(content) ? (
        <CardLoader />
      ) : (
        <Fragment>
          <QuillPreview>
            <ReadOnlyQuill value={content as string} />
          </QuillPreview>
        </Fragment>
      )}
    </Fragment>
  );
}
